export const base_url = 'https://us-central1-data-science-314706.cloudfunctions.net'